import { MemberDatasource, IMemberDatasource } from './../../..//global/datasources/member_datasource';

export class TransferCreditsController {
  models: {
    member: IMemberDatasource;
  };

  constructor(ngMemberDatasource: MemberDatasource, private $state: angular.ui.IStateService) {
    this.models = {
      member: ngMemberDatasource.read()
    };
  }
}
angular.module('capability-ng-transfer').controller('ngTransferCreditsController', TransferCreditsController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/transfer_credits/transfer_credits.ts